import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-tooltip',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div 
      [class]="getTooltipClasses()"
      [style.opacity]="isVisible ? '1' : '0'"
      class="px-3 py-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg whitespace-nowrap transition-opacity duration-200 pointer-events-none">
      {{ text }}
      <div [class]="getArrowClasses()" class="absolute w-2 h-2 bg-gray-900 transform rotate-45"></div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      position: absolute;
    }
  `]
})
export class TooltipComponent {
  @Input() text = '';
  @Input() position: 'top' | 'bottom' | 'left' | 'right' = 'top';
  
  isVisible = false;

  show(): void {
    this.isVisible = true;
  }

  hide(): void {
    this.isVisible = false;
  }

  public getTooltipClasses(): string {
    return 'relative';
  }

  public getArrowClasses(): string {
    switch (this.position) {
      case 'top':
        return 'top-full left-1/2 transform -translate-x-1/2 -translate-y-1/2';
      case 'bottom':
        return 'bottom-full left-1/2 transform -translate-x-1/2 translate-y-1/2';
      case 'left':
        return 'left-full top-1/2 transform -translate-y-1/2 -translate-x-1/2';
      case 'right':
        return 'right-full top-1/2 transform -translate-y-1/2 translate-x-1/2';
      default:
        return 'top-full left-1/2 transform -translate-x-1/2 -translate-y-1/2';
    }
  }
}
